import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyvalue'
})
export class KeyValuePipe implements PipeTransform {

  transform(item: any): any {
    if (!item || typeof item !== 'object' || Array.isArray(item)) {
      return [];
    }
    
    // Return array of {key, value} objects like Angular's built-in KeyValuePipe
    return Object.keys(item).map(key => ({
      key: key,
      value: item[key]
    }));
  }

}